"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
_export_star(require("./autoflow-resource-log"), exports);
_export_star(require("./etl-manual-trigger-resource-log"), exports);
_export_star(require("./review-cycle-resource-log"), exports);
_export_star(require("./scim-resource-log"), exports);
_export_star(require("./survey-resource-log"), exports);
_export_star(require("./user-deactivation-resource-log"), exports);
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function() {
                    return from[k];
                }
            });
        }
    });
    return from;
}
